<div class="page-content">
  <mood-admin-config-fieldset legendTitle="Geonetwork entries with linked data">
    <div class="cards">
      <mat-accordion multi="true">
        <ng-container *ngFor="let link of geonetworkLinks">
          <mood-issues-geonetwork-entry-admin [entry]="link"></mood-issues-geonetwork-entry-admin>
        </ng-container>
      </mat-accordion>
    </div>
  </mood-admin-config-fieldset>

  <mood-admin-config-fieldset legendTitle="Geonetwork entries with missing datasets">
    <div class="cards">
      <mat-accordion multi="true">
        <ng-container *ngFor="let link of geonetworkNoLinks">
          <mood-issues-geonetwork-entry-admin [entry]="link"></mood-issues-geonetwork-entry-admin>
        </ng-container>
      </mat-accordion>
    </div>
  </mood-admin-config-fieldset>

  <mood-admin-config-fieldset legendTitle="Datasets without Geonetwork links">
    <div class="cards">
      <mood-issues-dataset-card-admin *ngFor="let dataset of missingGeonetworkLinks"
        [dataset]="dataset"></mood-issues-dataset-card-admin>
    </div>
  </mood-admin-config-fieldset>

  <mood-admin-config-fieldset legendTitle="Datasets with invalid Geonetwork links">
    <div class="cards">
      <mood-issues-dataset-card-admin *ngFor="let dataset of invalidGeonetworkLinks"
        [dataset]="dataset"></mood-issues-dataset-card-admin>
    </div>
  </mood-admin-config-fieldset>
</div>
